import React from 'react';
import { UsefulLinksProvider } from './context/useful-links-context';
import { UsefulLinksComponent } from './useful-links-component';
import { BaseLayoutFactory } from '../global/base-layout-factory';

export function UsefulLinksFactory() {
    return (
        <BaseLayoutFactory>
            <UsefulLinksProvider>
                <UsefulLinksComponent />
            </UsefulLinksProvider>
        </BaseLayoutFactory>
    );
}
